import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FieldsetList from '../FieldSetList';

import InsuranceDetails from '../InsuranceDetails';
import { getPatientInfoFieldsetList } from '../utils/getInfoFieldset';

import { enhance } from './enhance';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { GATrackPageView } from '../../../gtag';

class PatientInfo extends Component {
  componentDidMount() {
    GATrackPageView('Profile | Patient Info');
  }

  saveUser = data => {
    const {
      canEditPatient,
      savePatientByProvider,
      savePatient,
      savePreferredPharmacy,
      profile,
    } = this.props;

    switch (true) {
      case canEditPatient:
        savePatientByProvider({ ...data });
        break;
      case Boolean(data.pharmacy):
        if (data.pharmacy.id) {
          savePreferredPharmacy({
            pharmacyId: data.pharmacy.id,
            userId: profile.id,
          });
        }
        break;
      default:
        savePatient({ ...data });
    }
  };

  render() {
    const { profile, canEdit } = this.props;
    const { primaryPatientProfile } = profile;
    const { id } = primaryPatientProfile || {};
    return (
      <div styleName="content content--profile content--info">
        <MetaHelmet title="pages.title.profile.patientInfo" />

        <div styleName="info">
          <div styleName="common">
            <InsuranceDetails />
            <FieldsetList
              fieldSetList={getPatientInfoFieldsetList(this.props)}
              onSave={data => this.saveUser({ ...data, id })}
              disabled={!canEdit}
              canEdit={canEdit}
            />
          </div>
        </div>
      </div>
    );
  }
}

PatientInfo.propTypes = {
  canEdit: PropTypes.bool,
  canEditPatient: PropTypes.bool,
  savePatient: PropTypes.func,
  savePatientByProvider: PropTypes.func,
  profile: PropTypes.object,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  savePreferredPharmacy: PropTypes.func,
};

export default enhance(PatientInfo);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PatientInfo/index.jsx